// extracted by mini-css-extract-plugin
module.exports = {"container":"layout_container__3s824","mainContainer":"layout_mainContainer__3P7Eh"};